<template>
  <div>
    <div class="my-10">
      <h1 class="text-3xl font-bold text-center">{{ __("Edit profile") }}</h1>

      <div class="bg-white p-4 shadow-md mt-10">
        <div class="max-w-md w-full mx-auto my-10 flex flex-col items-center">

          <div class="flex flex-col items-center">
            <form class="mt-2 flex flex-col items-center" @submit.prevent="submitProfileImageForm">
              <image-input v-model="profileImageForm.profileImage" :data-error="error('profileImage')" :image-url="user.profile_image_url" :show-delete-button="!defaultProfileImage" @deleteImage="deleteProfileImage()" class="w-full" type="file"/>

              <button v-if="profileImageForm.profileImage" type="submit" class="btn-primary mt-2">
                {{ __("Change image") }}
              </button>
            </form>
          </div>

          <form @submit.prevent="submitProfileForm" class="w-full mt-10">
            <text-input v-model="profileForm.name" :data-error="error('name')" class="w-full pb-8" :label="__('Name')"/>
            <text-input v-model="profileForm.email" :data-error="error('email')" class="w-full pb-8" :label="__('Email')"/>
            <text-input v-model="profileForm.phone_number" :data-error="error('phone_number')" class="w-full pb-8" :label="__('Phone')"/>

            <div class="flex justify-center items-center mt-4">
              <loading-button :loading="sendingProfileForm" class="btn-primary" type="submit">
                {{ __("Save") }}
              </loading-button>
            </div>
          </form>
        </div>
      </div>

      <div class="bg-white p-4 mt-20 shadow-md">
        <h1 class="text-3xl font-bold text-center mt-10">
          {{ __("Change password") }}
        </h1>

        <div class="max-w-md w-full mx-auto mb-10 flex flex-col items-center">
          <form @submit.prevent="submitPasswordForm" class="w-full mt-10">
            <text-input type="password" v-model="passwordForm.current_password" :data-error="error('current_password')" class="w-full pb-8" :label="__('Current password')"/>
            <text-input type="password" v-model="passwordForm.password" :data-error="error('password')" class="w-full pb-8" :label="__('New password')"/>
            <text-input type="password" v-model="passwordForm.password_confirmation" :data-error="error('password_confirmation')" class="w-full pb-8" :label="__('New password confirmation')"/>
            <div class="flex justify-center items-center">
              <loading-button :loading="sendingPasswordForm" class="btn-primary" type="submit">
                {{ __("Save") }}
              </loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import FileInput from '@/Shared/FileInput';
  import ImageInput from '@/Shared/ImageInput';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Edit profile")
      }
    },
    props: {
      user: Object,
      filters: null
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      FileInput,
      ImageInput,
      Icon
    },
    data() {
      return {
        sendingDeleteProfileImage: false,
        sendingProfileImageForm: false,
        sendingProfileForm: false,
        sendingPasswordForm: false,
        profileImageForm: {
          profileImage: null,
        },
        profileForm: {
          name: null,
          email: null,
          phone_number: null,
        },
        passwordForm: {
          current_password: null,
          password: null,
          password_confirmation: null,
        }
      }
    },
    mounted() {
      this.profileForm.name = this.user.name;
      this.profileForm.email = this.user.email;
      this.profileForm.phone_number = this.user.phone_number;
    },

    methods: {
      submitProfileImageForm() {
        this.sendingProfileImageForm = true;

        let data = new FormData();
        data.append('profileImage', this.profileImageForm.profileImage || '');
        data.append('_method', 'put');

        this.$inertia.post(this.route('profileImage.update', {user: this.user.id}), data, {
          preserveScroll: true,
          preserveState: false
        })
      },
      deleteProfileImage() {
        this.$inertia.delete(this.route('profileImage.destroy', {user: this.user.id}), {
          preserveScroll: true,
        });
      },
      submitProfileForm() {
        this.sendingProfileForm = true;
        this.$inertia.put(this.route('profile.update'), this.profileForm, {
          preserveScroll: true,
          preserveState: false
        });
      },
      submitPasswordForm() {
        this.sendingPasswordForm = true;
        this.$inertia.put(this.route('password.update'), this.passwordForm, {
          preserveScroll: true,
          preserveState: false
        })
      }
    },
    computed: {
      defaultProfileImage() {
        return this.$page.props.config.defaultProfileImageUrl === this.user.profile_image_url;
      }
    }
  }
</script>
